import { render, staticRenderFns } from "./OCFormLabel.html?vue&type=template&id=04b16464&scoped=true&"
import script from "./OCFormLabel.ts?vue&type=script&lang=ts&"
export * from "./OCFormLabel.ts?vue&type=script&lang=ts&"
import style0 from "./OCFormLabel.css?vue&type=style&index=0&id=04b16464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b16464",
  null
  
)

export default component.exports